import type { Voice } from 'ml-text-service-client';
import { useMemo } from 'react';

export function useVoiceoverFilters(results: Voice[]): {
    gender: string[];
    tone: string[];
    useCase: string[];
    accent: string[];
} {
    const filters = useMemo(() => {
        const filterOptions = {
            gender: new Set(),
            tone: new Set(),
            useCase: new Set(),
            accent: new Set(),
        };

        results.forEach((item) => {
            if (item.gender) {
                filterOptions.gender.add(item.gender);
            }
            if (item.descriptive) {
                filterOptions.tone.add(item.descriptive);
            }
            if (item.use_case) {
                filterOptions.useCase.add(item.use_case);
            }
            if (item.accent) {
                filterOptions.accent.add(item.accent);
            }
        });

        return {
            gender: Array.from(filterOptions.gender) as string[],
            tone: Array.from(filterOptions.tone) as string[],
            useCase: Array.from(filterOptions.useCase) as string[],
            accent: Array.from(filterOptions.accent) as string[],
        };
    }, [results]);

    return filters;
}

export function validateFileSize(file: File, setError: (err: string) => void): boolean {
    if (file.size > 10 * 1024 * 1024) {
        setError('File size must be less than 10MB');
        return false;
    }
    return true;
}

export function formatDisplayText(text: string | null | undefined): string {
    if (!text) return '';
    const result = text.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

    return result.replace(/\bTv\b/g, 'TV');
}
